export const posthogEvents = {
  selectEmailSignIn: 'Select email sign in',
  selectWorkspacePasswordSignIn: 'Select workspace password sign in',
  selectSsoSignIn: 'Select SSO sign in',
  attemptEmailSignIn: 'Attempt email sign in',
  attemptWorkspacePasswordSignIn: 'Attempt workspace password sign in',
  attemptSsoSignIn: 'Attempt SSO sign in', // Not used yet due to Posthog not being available on BE
  emailSignInSuccessful: 'Email sign in successful',
  workspacePasswordSignInSuccessful: 'Workspace password sign in successful',
  ssoSignInSuccessful: 'SSO sign in successful', // Not used yet due to Posthog not being available on BE
  selectForgotPassword: 'Select forgot password',
  requestResetPasswordLink: 'Request reset password link',
  attemptResetPassword: 'Attempt reset password',
  resetPasswordSuccessful: 'Reset password successful',
  selectPassword: 'Select password',
  attemptChangePassword: 'Attempt change password',
  changePasswordSuccessful: 'Change password successful'
};
